import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'era-devices-unavailable-badge-ui',
  templateUrl: './devices-unavailable-badge.component.html',
  styleUrls: ['./devices-unavailable-badge.component.scss'],
  imports: [RouterLink],
})
export class DevicesUnavailableBadgeComponent {
  @Input() count: number;
}
